// BuildingDetailsHotWaterAdd.js
import React, { useEffect, useState } from 'react';
import {
    Box, TextField, Button, Typography, Stack, MenuItem
} from '@mui/material';
import axios from 'axios';

const systemTypeOptions = ['electric', 'gas', 'oil'];

const BuildingDetailsHotWaterAdd = ({ buildingId, system, onSuccess, onError, onClose }) => {
    const [formData, setFormData] = useState({
        system_type: '',
        daily_water_usage: '',
        temperature_rise: '',
        efficiency: ''
    });

    useEffect(() => {
        if (system) {
            setFormData({
                system_type: system.system_type || '',
                daily_water_usage: system.daily_water_usage || '',
                temperature_rise: system.temperature_rise || '',
                efficiency: system.efficiency || ''
            });
        }
    }, [system]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            ...formData,
            daily_water_usage: parseFloat(formData.daily_water_usage),
            temperature_rise: parseFloat(formData.temperature_rise),
            efficiency: parseFloat(formData.efficiency),
            building: parseInt(buildingId)
        };

        const url = system
            ? `/buildings/${buildingId}/hot-water-systems/${system.id}/`
            : `/buildings/${buildingId}/hot-water-systems/`;

        const method = system ? axios.put : axios.post;

        method(url, payload)
            .then(() => {
                onSuccess();
                onClose();
            })
            .catch(() => onError());
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2, width: 400 }}>
            <Typography variant="h6" gutterBottom mb={2}>
                {system ? 'Edit Hot Water System' : 'Add Hot Water System'}
            </Typography>
            <Stack spacing={2}>
                <TextField
                    select
                    label="System Type"
                    name="system_type"
                    value={formData.system_type}
                    onChange={handleChange}
                    required
                    fullWidth
                    disabled={!!system}
                >
                    {systemTypeOptions.map((type) => (
                        <MenuItem key={type} value={type}>
                            {type.charAt(0).toUpperCase() + type.slice(1)}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField
                    label="Daily Water Usage (liters)"
                    name="daily_water_usage"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={formData.daily_water_usage}
                    onChange={handleChange}
                    required
                    fullWidth
                />

                <TextField
                    label="Temperature Rise (°C)"
                    name="temperature_rise"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={formData.temperature_rise}
                    onChange={handleChange}
                    required
                    fullWidth
                />

                <TextField
                    label="Efficiency (%)"
                    name="efficiency"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={formData.efficiency}
                    onChange={handleChange}
                    required
                    fullWidth
                />

                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="outlined" color="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="contained">
                        {system ? 'Save' : 'Add'}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BuildingDetailsHotWaterAdd;
